import { render } from "./SideMemuLayout.vue?vue&type=template&id=32710313&scoped=true"
import script from "./SideMemuLayout.vue?vue&type=script&lang=ts"
export * from "./SideMemuLayout.vue?vue&type=script&lang=ts"

import "./SideMemuLayout.vue?vue&type=style&index=0&id=32710313&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-32710313"

export default script